import React from 'react';
import Lottie from 'react-lottie';

import PaymentAppointmentLoader from '../../../assets/images/lotties/PaymentAccountFormLoader.json';

import styles from './styles.module.styl';

const animationOptions = {
  loop: true,
  autoplay: true,
  animationData: PaymentAppointmentLoader,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const PaymentAccountFormLoader = () => {
  return (
    <section className={styles.section}>
      <Lottie options={animationOptions} height={100} width={100} />
    </section>
  );
};

export default PaymentAccountFormLoader;



// WEBPACK FOOTER //
// ./src/components/common/PaymentAccountFormLoader/index.jsx